<template>
  <base-detail :title="'Veg Main Course'">
    <ul>
      <li class="menuList" v-for="item in vegStarters" :key="item.item">
        <span>{{ item.item }}</span>
        <span> {{ item.singlePrice || "----" }} </span>
        <span>{{ item.halfPrice || "----" }}</span>
        <span>{{ item.fullPrice }}</span>
      </li>
    </ul>
  </base-detail>
</template>

<script>
import data from "./../../../data.json";
export default {
  computed: {
    vegStarters() {
      const dataList = data.filter(
        (row) => row.type === "veg" && row.mealType === "main_course"
      );
      return dataList;
    },
  },
};
</script>
